import Paper from "@mui/material/Paper";
import TextField from "components/TextFieldInput";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { PROP_TYPES, DEFAULT_STATE } from "pages/order/prop-types";
import {
  StyledTableRow,
  StyledTableRow1,
  StyledTableRow2,
  WorkOrderHeading,
  StyledDisabledByDefaultIcon,
} from "styles/pages/order";

const SalesOrderOtherCharges = ({ state, setState }) => {
  const handleOtherChargesChange = (key, value, index) => {
    setState({
      ...state,
      otherCharges: state?.otherCharges?.map((row, j) => {
        if (index !== j) return row;
        return {
          ...row,
          [key]: value,
        };
      }),
    });
  };

  const getTotalAmount = () => {
    let totalAmount = 0;

    for (let i = 0; i < state?.lineItems?.length; i += 1) {
      totalAmount += Number(state?.lineItems[i]?.chargeAmount) || 0;
    }

    for (let i = 0; i < state?.otherCharges?.length; i += 1) {
      totalAmount += Number(state?.otherCharges[i]?.chargeAmount) || 0;
    }

    return totalAmount.toFixed(2);
  };

  return (
    <>
      <Paper elevation={3} sx={{ marginTop: "20px" }}>
        <WorkOrderHeading>
          <div>Other Charges</div>
          <AddCircleIcon
            sx={{ cursor: "pointer" }}
            onClick={() =>
              setState({
                ...state,
                otherCharges: [{ taxPercentage: 13 }, ...state.otherCharges],
              })
            }
          />
        </WorkOrderHeading>
        {state?.otherCharges?.map((row, i) => {
          const key = i;
          return (
            <StyledTableRow key={`editedLineItems_${key}`} even={i % 2 === 0}>
              <StyledDisabledByDefaultIcon
                onClick={() =>
                  setState({
                    ...state,
                    otherCharges: state?.otherCharges?.filter(
                      (r, j) => i !== j
                    ),
                  })
                }
              />
              <StyledTableRow1>
                <TextField
                  label="Description"
                  error={!row?.description?.trim()}
                  value={row?.description}
                  handleChange={(e) =>
                    handleOtherChargesChange("description", e?.target?.value, i)
                  }
                />
              </StyledTableRow1>
              <StyledTableRow2>
                <TextField
                  label="Quantity"
                  error={!row?.qty}
                  value={row?.qty}
                  type="number"
                  handleChange={(e) => {
                    const qty = Number(e.target.value);
                    setState({
                      ...state,
                      otherCharges: state?.otherCharges?.map((r, j) => {
                        if (i !== j) return r;
                        const unitCost = Number(r.unitCost);
                        const taxPercentage = Number(r.taxPercentage);
                        const taxCharged =
                          unitCost * qty * (taxPercentage / 100);
                        const chargeAmount = unitCost * qty + taxCharged;
                        return {
                          ...r,
                          qty,
                          taxCharged,
                          chargeAmount,
                        };
                      }),
                    });
                  }}
                />

                <TextField
                  label="Unit Cost"
                  error={!row?.unitCost}
                  value={row?.unitCost}
                  disabled={!row?.qty}
                  type="number"
                  handleChange={(e) => {
                    const unitCost = Number(e.target.value);
                    setState({
                      ...state,
                      otherCharges: state?.otherCharges?.map((r, j) => {
                        if (i !== j) return r;
                        const qty = Number(r.qty);
                        const taxPercentage = Number(r.taxPercentage);
                        const taxCharged =
                          unitCost * qty * (taxPercentage / 100);
                        const chargeAmount = unitCost * qty + taxCharged;
                        return {
                          ...r,
                          unitCost,
                          taxCharged,
                          chargeAmount,
                        };
                      }),
                    });
                  }}
                />

                <TextField
                  label="Tax Percentage"
                  error={!row?.taxPercentage}
                  value={row?.taxPercentage}
                  disabled={!row?.unitCost || !row?.qty}
                  type="number"
                  handleChange={(e) => {
                    const taxPercentage = Number(e.target.value);
                    setState({
                      ...state,
                      otherCharges: state?.otherCharges?.map((r, j) => {
                        if (i !== j) return r;
                        const unitCost = Number(r.unitCost);
                        const qty = Number(r.qty);
                        const taxCharged =
                          unitCost * qty * (taxPercentage / 100);
                        const chargeAmount = unitCost * qty + taxCharged;
                        return {
                          ...r,
                          taxPercentage,
                          taxCharged,
                          chargeAmount,
                        };
                      }),
                    });
                  }}
                />

                <TextField
                  label="Tax Charged"
                  disabled
                  value={Number(row?.taxCharged || 0).toFixed(2)}
                  type="number"
                />

                <TextField
                  label="Charge Amount"
                  error={!row?.chargeAmount}
                  value={Number(row?.chargeAmount || 0).toFixed(2)}
                  disabled
                />
              </StyledTableRow2>
            </StyledTableRow>
          );
        })}
      </Paper>
      <p style={{ textAlign: "right" }}>
        <b>
          Total Amount:&nbsp;
          <span style={{ fontSize: "30px" }}>{getTotalAmount()}</span>
        </b>
      </p>
      <p>
        <b>
          Please email us at customerservice@bigoventees.com if you have any
          questions or concerns.
        </b>
      </p>
    </>
  );
};

SalesOrderOtherCharges.propTypes = PROP_TYPES;

SalesOrderOtherCharges.defaultProps = DEFAULT_STATE;

export default SalesOrderOtherCharges;
